import { BaseApiRouteService } from "mrb/core";

class ProducerPreviewReportPeriodCellApiRouteService extends BaseApiRouteService {
    constructor() {
        super("producer/reports");
    }

    findProducerReportPayoutUserEvents(filter) {
        return super.find(
            `${this.base}/payout-user-events/{?producerId,userId,deviceIds,from,to,page,rpp,sort,embed,fields}`,
            filter
        );
    }

    findProducerReports(filter) {
        return super.find(`${this.base}/{?producerId,from,to,page,rpp,sort,embed,fields}`, filter);
    }

    getProducerPaymentSummary(producerId, options) {
        return super.get(`${this.base}/summary{?producerId,from,to}`, producerId, options);
    }

    findProducerReportItems(filter) {
        return super.find(`${this.base}/items{?producerId,searchQuery,from,to,page,rpp,sort,embed,fields}`, filter);
    }

    findProducerReportTrackItems(filter) {
        return super.find(
            `${this.base}/track-items{?producerId,searchQuery,contentId,from,to,page,rpp,sort,embed,fields}`,
            filter
        );
    }

    findProducerReportContentItems(filter) {
        return super.find(
            `${this.base}/content-items{?producerId,searchQuery,from,to,page,rpp,sort,embed,fields}`,
            filter
        );
    }

    findProducerReportTrackListeners(filter) {
        return super.find(
            `${this.base}/track-listeners{?producerId,contentId,trackId,searchQuery,from,to,page,rpp,sort,embed,fields}`,
            filter
        );
    }

    findRevenueMap(filter) {
        return super.find(`${this.base}/revenue-map{?producerId}`, filter);
    }

    getProducerReportTrackItemsCsv(filter, producerId) {
        return super.find(`${this.base}/track-items-csv{?producerId,from,to}`, { producerId, ...filter });
    }
}

export default ProducerPreviewReportPeriodCellApiRouteService;
